export const filesDataGetter = (params) => {
    const {data} = params
    const {company, campaign} = data
  
    if(company.purchase_orders){
      return {
        campaign_id: campaign.id,
        is_programmatic: campaign.is_programmatic,
        files: company.purchase_orders.map((fileData) => fileData)
      }
    }
  
    return {
      campaign_id: campaign.id,
      is_programmatic: campaign.is_programmatic,
      files: []
    }
}

const paymentGetters = {
  operation: {
    getGuarantee: (params) => params.data.operation.guaranteed ? 'Si' : 'No', // Aún no está implementado
    getCurrencyToPay: (params) => params.data.operation.currency_to_pay,
    getAmountConsumed: (params) => params.data.operation.amount_consumed,
    getAmountBudgeted: (params) => params.data.operation.amount_budgeted,
    getAmountFinal: (params) => { // PROBAR
        //Si es garantizado, toma 'estimado', si no es garantizado toma 'consumido'
        const value = params.data.operation.guarantee ? params.data.operation.amount_budgeted : params.data.operation.amount_consumed
    
        return value
    },
    getTax: (params) => (params.data.operation.tax ? `${parseFloat(params.data.operation.tax)}%` : '-'),
    getFinalWithTax: (params) => {
        const value = params.data.operation.guarantee ? params.data.operation.amount_budgeted : params.data.operation.amount_consumed
        const tax = params.data.operation.tax ? parseFloat(params.data.operation.tax) : 0

        const finalWithTax = parseFloat(value) + (parseFloat(value) * (tax/100))
        if (!finalWithTax) return 0

        return finalWithTax
    },
    getRateFromCurrency: (params) => params.data.operation.rates ? params.data.operation.rates.from.currency : '-',
    getRateToCurrency: (params) => params.data.operation.rates ? params.data.operation.rates.to.currency : '-',
    getExternalDsp: (params) => (params.data.campaign.external_dsp.id ? `${params.data.campaign.external_dsp.name} (${params.data.campaign.external_dsp.exchange})` : 'DSP LatinAd'),
    getPaymentDate: (params) => params.data.operation.payment_date,
    getPaymentDelay: params => {
      if (!params.data.operation.payment_date) return '-'
  
      const paymentDate = new Date(params.data.operation.payment_date)
      const today = new Date()
  
      const diference = today - paymentDate
  
      const daysUntilExpiration = Math.floor(diference / (1000 * 60 * 60 * 24));
  
      return daysUntilExpiration > 0 ? `${daysUntilExpiration} días de atraso` : `Faltan ${daysUntilExpiration * -1} días para el pago`
    },
    getRate: (params) => params.data.operation.rate,
    getPromisedShows: (params) => params.data.operation.promised_shows || '-',
    getImpressionsShowed: (params) => params.data.operation.impressions_showed || '-',
    getRatesToRate: (params) => params.data.operation.rates ? params.data.operation.rates.to.rate : '-',
    getRatesFromRate: (params) => params.data.operation.rates ? params.data.operation.rates.from.rate : '-'
  },
  campaign: {
    getId: (params) => params.data.campaign.id,
    getName: (params) => params.data.campaign.name,
    getMultiMonth: (params) => params.data.campaign.is_campaign_longer_than_one_month ? "Si" : "No",
    getFromDate: (params) => params.data.campaign.start_date,
    getToDate: (params) => params.data.campaign.end_date,
    getCampaignType: (params) => params.data.campaign.is_programmatic ? 'Programática' : 'Tradicional',
    getComment: (params) => params.data.campaign.comments
  },
  company: {
    getId: (params) => params.data.company.id,
    getName: (params) => params.data.company.name,
    getHolding: (params) => (params.data.company.holding ? `${params.data.company.holding.name} (${params.data.company.holding.id})` : '-'),
    getCountry: (params) => params.data.company.country,
    getProgrammaticProvider: (params) => (params.data.campaign.programmatic_provider ? `${params.data.campaign.programmatic_provider.name}` : '-')
  }
}

export default paymentGetters;